var strip_html;

module.exports = strip_html = function(str, tags) {
  if (tags == null) {
    tags = null;
  }
  if (!str) {
    return str;
  }
  if (tags) {
    str = str.replace(new RegExp("</?\\s*(" + (tags.join('|')) + ")( [^>]*)?>", "g"), '');
  } else {
    str = str.replace("</p>", "\n\n").replace("<p>", "");
    str = str.replace(/(<\?[a-z]*(\s[^>]*)?\?(>|$)|<!\[[a-z]*\[|\]\]>|<!DOCTYPE[^>]*?(>|$)|<!--[\s\S]*?(-->|$)|<[a-z?!\/]([a-z0-9_:.])*(\s[^>]*)?(>|$))/gi, '');
  }
  return str;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvZHNlaWZlcnQvbmFwaXN0cmFuby9idWlsZC8xNDk2MTc5ODkzMzEwLTI2ODExL3JlbGVhc2UtMTAuMS4xMC9zZW9fcGxhdGZvcm1faXRpZXIvbW9kdWxlcy9oZWxwZXJzL2Zyb250ZW5kL2h0bWwuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvZHNlaWZlcnQvbmFwaXN0cmFuby9idWlsZC8xNDk2MTc5ODkzMzEwLTI2ODExL3JlbGVhc2UtMTAuMS4xMC9zZW9fcGxhdGZvcm1faXRpZXIvbW9kdWxlcy9oZWxwZXJzL2Zyb250ZW5kL2h0bWwuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsVUFBQSxHQUFhLFNBQUMsR0FBRCxFQUFNLElBQU47O0lBQU0sT0FBTzs7RUFHekMsSUFBQSxDQUFrQixHQUFsQjtBQUFBLFdBQU8sSUFBUDs7RUFFQSxJQUFHLElBQUg7SUFDRSxHQUFBLEdBQU0sR0FBRyxDQUFDLE9BQUosQ0FBWSxJQUFJLE1BQUosQ0FBVyxVQUFBLEdBQVUsQ0FBQyxJQUFJLENBQUMsSUFBTCxDQUFVLEdBQVYsQ0FBRCxDQUFWLEdBQTBCLGFBQXJDLEVBQW1ELEdBQW5ELENBQVosRUFBcUUsRUFBckUsRUFEUjtHQUFBLE1BQUE7SUFJRSxHQUFBLEdBQU0sR0FBRyxDQUFDLE9BQUosQ0FBWSxNQUFaLEVBQW9CLE1BQXBCLENBQTJCLENBQUMsT0FBNUIsQ0FBb0MsS0FBcEMsRUFBMkMsRUFBM0M7SUFDTixHQUFBLEdBQU0sR0FBRyxDQUFDLE9BQUosQ0FBWSxvSUFBWixFQUFrSixFQUFsSixFQUxSOztTQU9BO0FBWjRCIn0=
